import { Scrollbars } from 'rc-scrollbars';
import React, { useRef } from 'react';

import Categories from './categories';
import Regions from './regions';
import Section from './section';
import Tags from './tags';

const MAX_HEIGHT = 290;

const MenuCategoriesComponent = React.memo(() => {
  const scrollbar = useRef();
  return (
    <Scrollbars ref={scrollbar} style={{ height: MAX_HEIGHT, width: '100%' }}>
      <Section title="Filter par type">
        <Categories />
      </Section>
      <Section title="Filter par catégorie">
        <Tags />
      </Section>
      <Section title="Filter par region">
        <Regions />
      </Section>
    </Scrollbars>
  );
});

MenuCategoriesComponent.displayName = 'MenuCategoriesComponent';

export default MenuCategoriesComponent;
